import { QueryHookOptions } from '@apollo/client';

import { useInfiniteQuery } from 'hooks/useInfiniteQuery';

import query from './managedDepotsFiltersQuery.graphql';

export const useDepotsFiltersQuery = (
  options?: QueryHookOptions<
    ManagedDepotsFiltersQuery,
    ManagedDepotsFiltersQueryVariables
  >,
) => {
  return useInfiniteQuery<
    ManagedDepotsFiltersQuery,
    ManagedDepotsFiltersQueryVariables
  >(query, {
    fieldName: 'managedAssetGroupings',
    ...options,
  });
};
